/**
 * Keep copying useful on local HTTP and when clipboard permission is denied.
 * Only report success when one of the browser's copy operations succeeds.
 */
export const copyJournalLink = async (input, {
    clipboard = globalThis.navigator?.clipboard,
    copySelection = () => document.execCommand('copy'),
} = {}) => {
    try {
        if (clipboard?.writeText) {
            await clipboard.writeText(input.value);
            return true;
        }
    } catch {
        // The visible field also supports manual copying if both APIs fail.
    }

    input.focus({ preventScroll: true });
    input.select();
    input.setSelectionRange(0, input.value.length);
    try {
        return copySelection() === true;
    } catch {
        return false;
    }
};
